import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ResourceTaskTime } from "../../../entities/ResourceTaskTime";
import { AppFile } from "../../../entities/AppFile";
import { FileService } from "../../../services/file.service";
import { IMyDpOptions, IMyDateModel } from "mydatepicker";
import { environment } from "../../../../environments/environment";
import * as moment from 'moment';


@Component({
  selector: 'app-modal-rtt',
  templateUrl: './modal-rtt.component.html',
  styleUrls: ['./modal-rtt.component.css']
})

export class ModalRttComponent implements OnInit {
  _chosenRTT: ResourceTaskTime = new ResourceTaskTime();

  @Input('chosenRTT')
  set chosenRTT(rtt: any) {
    Object.assign(this._chosenRTT, rtt);
    this.InitDatapickers();
    this.getFiles(rtt);
  }

  @Input()
  isAdmin: boolean;

  filesToDownload: AppFile[] = [];

  @Output()
  updateRttEmitter = new EventEmitter();

  filesToUpload: AppFile[] = [];

  currentFile: AppFile;

  loading: boolean;

  @ViewChild('myRTTInput')
  fileChooserValue: ElementRef;


  public startDatePickerOptions: IMyDpOptions;

  public endDatePickerOptions: IMyDpOptions;


  dummyStart: any;
  dummyEnd: any;

  constructor(private fileService: FileService) { }

  ngOnInit() {
    this.currentFile = new AppFile();

  }

  InitDatapickers() {
    this._chosenRTT.end = moment(new Date(this._chosenRTT.end).setDate(new Date(this._chosenRTT.end).getDate())).format(environment.START_DATETIME_FORMAT);
    //moment(new Date(calEvent.end).setDate(new Date(calEvent.end).getDate() - 1)).format(environment.START_DATETIME_FORMAT_DANISH)

    this.dummyStart = {
      date: {
        year: new Date(this._chosenRTT.start).getFullYear(),
        month: new Date(this._chosenRTT.start).getMonth() + 1,
        day: new Date(this._chosenRTT.start).getDate()
      }
    };

    this.dummyEnd = {
      date: {
        year: new Date(this._chosenRTT.end).getFullYear(),
        month: new Date(this._chosenRTT.end).getMonth() + 1,
        day: new Date(this._chosenRTT.end).getDate()
      }
    };

    this.setOptionsData();

  }

  updateRtt(chosenRtt) {
    this.updateRttEmitter.emit(chosenRtt);
  }

  onFileChange($event) {
    const files = $event.target.files;
    const filesToUpload = this.filesToUpload;
    const fcValue = this.fileChooserValue;
    const self = this;
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        const fileReader = new FileReader();
        let textFromFileLoaded;
        fileReader.onload = function (fileLoadedEvent: any) {
          textFromFileLoaded = fileLoadedEvent.target.result;

          const newFile = new AppFile();
          // base 64 encode
          newFile.File = btoa(textFromFileLoaded);
          newFile.Key = "{" + self._chosenRTT.GUID + "}";
          newFile.Type = "Resource Task Time";
          newFile.FileName = file.name;
          let d = new Date();
          newFile.Created_DateTime = d.toDateString();
          filesToUpload.push(newFile);
          if (i === files.length - 1) {
            fcValue.nativeElement.value = '';
          }
        };
        fileReader.readAsBinaryString(file);
      }
    }
  }

  uploadFiles() {
    if (this.filesToUpload.length > 0) {
      this.loading = true;
      this.fileService.uploadFiles(this.filesToUpload).subscribe(success => {
        this.loading = false;
        const length = this.filesToUpload.length;
        
        for (let j = 0; j < length; j++) {
          this.removeFile(this.filesToUpload[0]);
        }
        this.getFiles(this._chosenRTT);
      });
    }
  }

  removeFile(file: AppFile) {
    const index = this.filesToUpload.indexOf(file);
    if (index > -1) {
      this.filesToUpload.splice(index, 1);
    }
  }


  getFiles(rtt: ResourceTaskTime) {
    if (rtt.GUID != null)
      this.fileService.getFilesByKey(rtt.GUID, "Resource Task Time").subscribe(files => this.filesToDownload = files);
  }

  downloadFile(file) {
    this.fileService.downloadFile(file.No).subscribe(blob => {
      const fileUrl = URL.createObjectURL(blob);
      const nav = window.navigator as any;
      // for IE 10+
      if (nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(blob, file.FileName);
      } else {
        const element = document.createElement('a');
        element.href = fileUrl;
        element.setAttribute('download', file.FileName);
        element.setAttribute('target', '_blank');
        element.dispatchEvent(new MouseEvent('click'));
        URL.revokeObjectURL(fileUrl);
      }
    });
  }

  setOptionsData() {
    this.startDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{ begin: { year: new Date(this._chosenRTT.end).getFullYear(), month: new Date(this._chosenRTT.end).getMonth() + 1, day: new Date(this._chosenRTT.end).getDate() + 1 }, end: { year: 2055, month: 11, day: 20 } }],
    };
    this.endDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{ begin: { year: 1980, month: 11, day: 20 }, end: { year: new Date(this._chosenRTT.start).getFullYear(), month: new Date(this._chosenRTT.start).getMonth() + 1, day: new Date(this._chosenRTT.start).getDate() - 1 } }],
    };
  }

  setStartDate(event: IMyDateModel) {
    this._chosenRTT.start = event.jsdate.toDateString();

    this.setOptionsData();
  }

  setEndDate(event: IMyDateModel) {
    this._chosenRTT.end = event.jsdate.toDateString();

    this.setOptionsData();
  }

}






// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/modal-rtt/modal-rtt.component.ts